"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsProvider = exports.FeatureFlagsContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const react_1 = require("react");
class FeatureFlags {
    flags = new Map();
    enviroment;
    createFlag = (variableName, envValue) => {
        const newFlag = {
            name: variableName,
            variable: (0, client_1.makeVar)(this.getInitialValue(variableName, envValue)),
            envValue
        };
        return newFlag;
    };
    constructor(flagValues, buildEnv) {
        this.enviroment = buildEnv;
        this.setup(flagValues);
    }
    getInitialValue(variableName, initialValue) {
        if (this.enviroment === 'local' || this.enviroment === 'staging') {
            try {
                const localStorageItemValue = localStorage?.getItem(variableName);
                if (localStorageItemValue) {
                    return localStorageItemValue === 'true';
                }
            }
            catch (ex) {
                // Do nothing
            }
        }
        return initialValue;
    }
    setup(flags) {
        flags.forEach((flag) => {
            this.flags.set(flag.name, this.createFlag(flag.name, flag.envValue ?? false));
        });
    }
    getValue(name) {
        if (!this.flags.get(name)) {
            throw new Error(`Feature Flag ${name} does not exist`);
        }
        const flag = this.flags.get(name);
        return flag.variable;
    }
    setValue(name, value) {
        if (!this.flags.get(name)) {
            throw new Error(`Feature Flag ${name} does not exist`);
        }
        const flag = this.flags.get(name);
        flag.variable(value);
        localStorage.setItem(name, value.toString());
    }
}
exports.FeatureFlagsContext = (0, react_1.createContext)({});
const FeatureFlagsProvider = ({ children, featureFlagsValues, buildEnv }) => {
    const featureFlagsInstance = new FeatureFlags(featureFlagsValues, buildEnv);
    return (0, jsx_runtime_1.jsx)(exports.FeatureFlagsContext.Provider, { value: featureFlagsInstance, children: children });
};
exports.FeatureFlagsProvider = FeatureFlagsProvider;
//# sourceMappingURL=feature-flags.js.map